/**
 * @param {Node} [$parent] The node that should contain the other node.
 * @param {Node} [$descendant] The node to test presence of.
 * @return {boolean} Whether the parent node contains the descendant node.
 */
export default function contains($parent, $descendant) {
  if (!$parent || !$descendant) {
    return false;
  }

  if ($parent.contains) {
    return $parent === $descendant || $parent.contains($descendant);
  }

  while ($descendant && $parent !== $descendant) {
    // eslint-disable-next-line no-param-reassign
    $descendant = $descendant.parentNode;
  }

  return $descendant === $parent;
}
